var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.passthrough
        ? _vm._t("default")
        : _vm.blocked
        ? _c("ap3-access-dialog", {
            attrs: { site: _vm.site, access: _vm.access }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }